import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  loaded: false,
  data: {},
  saving: false,
});

const { Types, Creators } = createActions({
  getMerchandiseCodes: null,
  setMerchandiseCodes: ['data'],

  saveMerchandiseCode: ['params', 'callback'],
  setMerchandiseCode: ['merchandiseCode'],
});

export const setMerchandiseCodesReducer = (state, { data }) =>
  state.set('data', data).set('loaded', true)

export const setMerchandiseCodeReducer = (state, { merchandiseCode }) =>
  state.setIn(['data', merchandiseCode.id], merchandiseCode).set('saving', false)

export const saveMerchandiseCodeReducer = state => state.set('saving', true)

export const merchandiseCodeReducer = createReducer(INITIAL_STATE, {
  [Types.SET_MERCHANDISE_CODES]: setMerchandiseCodesReducer,
  [Types.SAVE_MERCHANDISE_CODE]: saveMerchandiseCodeReducer,
  [Types.SET_MERCHANDISE_CODE]: setMerchandiseCodeReducer,
})


export const MerchandiseCodeTypes = Types
export default Creators;


// WEBPACK FOOTER //
// ./src/reducers/merchandiseCodeReducer.js